export const PERMS = {
    READ: 'company_cost_centers.read',
    UPDATE: 'company_cost_centers.update',
    DELETE: 'company_cost_centers.delete',
    CREATE: 'company_cost_centers.create',
}
